import AddRoundedIcon from '@mui/icons-material/AddRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import FormatQuoteRoundedIcon from '@mui/icons-material/FormatQuoteRounded';
import TagRoundedIcon from '@mui/icons-material/TagRounded';
import { Box, Stack } from '@mui/material';
import { green } from '@mui/material/colors';
import { FeedbackLabelType } from 'v2/core/entities/feedback';

interface CreateOrUpdateLabelIconProps {
  action: 'create' | 'update';
  labelType: FeedbackLabelType.Entity | FeedbackLabelType.Reason;
}

export const CreateOrUpdateLabelIcon = ({
  action,
  labelType,
}: CreateOrUpdateLabelIconProps) => {
  return (
    <Stack
      pt={1}
      pr={0.5}
      width={80}
      height={80}
      borderRadius="50%"
      bgcolor={green[400]}
      position="relative"
      alignItems="center"
      justifyContent="center"
    >
      <Box position="absolute" top={12} left={50}>
        {action === 'create' ? (
          <AddRoundedIcon sx={{ fontSize: 20 }} />
        ) : (
          <CheckRoundedIcon sx={{ fontSize: 16 }} />
        )}
      </Box>
      {labelType === FeedbackLabelType.Reason ? (
        <FormatQuoteRoundedIcon sx={{ fontSize: 48 }} />
      ) : (
        <TagRoundedIcon sx={{ fontSize: 48 }} />
      )}
    </Stack>
  );
};
